import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import { CodomoLogoNew } from "../constant/images";
import { googleLogout } from "@react-oauth/google";
import { AuthenticationState } from "../App";

const Header = (props) => {

  const {
    setuserAuthenticated,
    setVerifiedAsMentor,
    verifiedAsMentor,
    verifiedAsAdmin,
    setVerifiedAsAdmin,
    verifiedAsBDE,
    setVerifiedAsBDE
  } = useContext(AuthenticationState);

  const [activeMobileMenu, setActiveMobileMenu] = useState(false);
  const [downloadoptions, setDownloadoptions] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const scrollNav = useRef(null);

  const selectedCourse = location.state?.course?.course_name;

  useEffect(() => {

    const storedData = sessionStorage.getItem("CourseKey");

    if (storedData && storedData !== "undefined" && storedData !== "null") {
      setDownloadoptions(JSON.parse(storedData));
    } else if (props.course) {
      setDownloadoptions(props.course);
    }

    const handleScroll = () => {
      const windowScroll = window.scrollY > 100;
      scrollNav.current?.classList.toggle("rt-sticky-active", windowScroll);
      scrollNav.current?.classList.toggle("sticky", windowScroll);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, [props.course]);

  const logOut = () => {
    googleLogout();
    navigate("/signIn");
    localStorage.clear();
    sessionStorage.clear();
    setuserAuthenticated(false);
    setVerifiedAsMentor(false);
    setVerifiedAsAdmin(false);
    setVerifiedAsBDE(false);
  };

  const isActive = (path) => {
    return location.pathname === path ? "text-red-600 font-bold" : "";
  };

  return (
    <>
      <header
        className="site-header home-one-header top-0 w-full z-[999] rt-sticky"
        ref={scrollNav}
      >
        <div className="main-header py-6">
          <div className="container">
            <div className="flex items-center justify-between">

              {/* Logo */}

              <Link
                to={"/codomo/home"}
                className="brand-logo flex-none lg:mr-10 md:w-auto max-w-[120px]"
              >
                <img
                  style={{ height: "60px" }}
                  src={CodomoLogoNew}
                  alt="Logo"
                />
              </Link>

              <div className="flex items-center flex-1">

                <div className="flex-1 main-menu relative mr-[74px]">

                  <ul className="menu-active-classNamees">

                    {/* HOME */}

                    <li className={isActive("/codomo/home")}>
                      <Link to={"/codomo/home"}>Home</Link>
                    </li>

                    {/* COURSE */}

                    {downloadoptions.length > 0 && (

                      <li
                        className={`menu-item-has-children ${
                          location.pathname === "/codomo/course"
                            ? "text-red-600 font-bold"
                            : ""
                        }`}
                      >

                        <a>Course</a>

                        <ul className="sub-menu">

                          {downloadoptions.map((item, index) => (

                            <li
                              key={index}
                              className={
                                selectedCourse === item.course_name
                                  ? "text-red-600 font-bold"
                                  : ""
                              }
                            >

                              <Link
                                to="/codomo/course"
                                state={{ course: item }}
                              >
                                {item.course_name}
                              </Link>

                            </li>

                          ))}

                        </ul>

                      </li>

                    )}

                    {/* DOWNLOADS */}

                    {downloadoptions.length > 0 && (

                      <li
                        className={`menu-item-has-children ${
                          location.pathname === "/codomo/course/downloads"
                            ? "text-red-600 font-bold"
                            : ""
                        }`}
                      >

                        <a>Downloads</a>

                        <ul className="sub-menu">

                          {downloadoptions.map((item, index) => (

                            <li
                              key={index}
                              className={
                                selectedCourse === item.course_name
                                  ? "text-red-600 font-bold"
                                  : ""
                              }
                            >

                              <Link
                                to="/codomo/course/downloads"
                                state={{ course: item }}
                              >
                                {item.course_name}
                              </Link>

                            </li>

                          ))}

                        </ul>

                      </li>

                    )}

                    {/* MENTOR */}

                    {verifiedAsMentor && (

                      <li className="menu-item-has-children">

                        <a>Mentor</a>

                        <ul className="sub-menu">

                          <li className={isActive("/codomo/mentor/activities")}>
                            <Link to="/codomo/mentor/activities">Batch Management</Link>
                          </li>

                          <li className={isActive("/codomo/mentor/notification")}>
                            <Link to="/codomo/mentor/notification">Notification Service</Link>
                          </li>

                          <li className={isActive("/codomo/mentor/admiration")}>
                            <Link to="/codomo/mentor/admiration">Student Admiration</Link>
                          </li>

                          <li className={isActive("/codomo/mentor/dashboard")}>
                            <Link to="/codomo/mentor/dashboard">Dashboard</Link>
                          </li>

                        </ul>

                      </li>

                    )}

                    {/* ADMIN */}

                    {verifiedAsAdmin && (

                      <li className="menu-item-has-children">

                        <a>Admin</a>

                        <ul className="sub-menu">

                          <li className={isActive("/codomo/admin/usermanagement")}>
                            <Link to="/codomo/admin/usermanagement">User Management</Link>
                          </li>

                          <li className={isActive("/codomo/admin/coursemanagement")}>
                            <Link to="/codomo/admin/coursemanagement">Course Management</Link>
                          </li>

                          <li className={isActive("/codomo/admin/assiginingcoursetomentor")}>
                            <Link to="/codomo/admin/assiginingcoursetomentor">Assign Course to Mentor</Link>
                          </li>

                          <li className={isActive("/codomo/admin/batchmanagement")}>
                            <Link to="/codomo/admin/batchmanagement">Batch Management</Link>
                          </li>

                          <li className={isActive("/codomo/admin/createbatch")}>
                            <Link to="/codomo/admin/createbatch">Create Batch</Link>
                          </li>

                        </ul>

                      </li>

                    )}

                    {/* CONTACT */}

                    {!verifiedAsMentor && (
                      <li className={isActive("/codomo/contactus")}>
                        <Link to="/codomo/contactus">Contact</Link>
                      </li>
                    )}

                  </ul>

                </div>

                {/* LOGOUT */}

                <div className="flex-none flex space-x-[18px]">

                  <div className="hidden lg:block">
                    <button
                      className="btn btn-primary py-[15px] px-8"
                      onClick={logOut}
                    >
                      Logout
                    </button>
                  </div>

                  {/* MOBILE MENU */}

                  <div className="block lg:hidden">
                    <button
                      type="button"
                      className="text-3xl md:w-[56px] h-10 w-10 md:h-[56px] rounded bg-[#F8F8F8] flex items-center justify-center"
                      onClick={() =>
                        setActiveMobileMenu(!activeMobileMenu)
                      }
                    >
                      ☰
                    </button>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
      </header>

      {activeMobileMenu && (
        <MobileMenu
          activeMenu={activeMobileMenu}
          setActiveMenu={setActiveMobileMenu}
          downloadoptions={downloadoptions}
          verifiedAsMentor={verifiedAsMentor}
          verifiedAsAdmin={verifiedAsAdmin}
        />
      )}

    </>
  );
};

export default Header;